import { useQuery } from "@apollo/client";
import { GET_OUTFITS_QUERY } from "@/graphql/queries";
import OutfitCard from "@/components/outfits/OutfitCard";
import Breadcrumb from "@/components/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { useFavoriteOutfit } from "@/hooks/useFavoriteOutfit";
import OutfitsEmptyState from "@/components/empty-states/OutfitsEmptyState";

export default function Dashboard() {
  // Fetch current user and outfits
  const { data, loading, error } = useQuery(GET_OUTFITS_QUERY);
  const outfits = data?.getCurrentUser?.outfits || [];
  const navigate = useNavigate();
  const { toggleFavorite } = useFavoriteOutfit();

  const handleFavoriteToggle = async (id: string) => {
    try {
      await toggleFavorite(id);
    } catch (error) {
      console.error('Failed to toggle favorite:', error);
    }
  };

  return (
    <>
      <Breadcrumb
        title="Home"
        trail={[{ label: `Welcome ${data?.getCurrentUser?.firstName}` }]}
      />
      {/* Outfits Grid */}
      <section className="mb-8">
        <div className="max-w-7xl mx-auto">
          {loading ? (
            <div className="text-gray-500 dark:text-gray-400">
              Loading outfits...
            </div>
          ) : error ? (
            <div className="text-red-500">
              Error loading outfits. {error.message}
            </div>
          ) : outfits.length === 0 ? (
            <OutfitsEmptyState />
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {outfits.map((outfit: any) => (
                <OutfitCard
                  key={outfit.id}
                  id={outfit.id}
                  occasion={outfit.occasion}
                  imageUrl={outfit.imageUrl}
                  outfitItems={outfit.outfitItems}
                  createdAt={outfit.createdAt}
                  updatedAt={outfit.updatedAt}
                  favorited={outfit.favorited}
                  onClick={() => navigate(`/lookbook/${outfit.id}`)}
                  onFavoriteToggle={handleFavoriteToggle}
                />
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
